import { render, staticRenderFns } from "./NextPrevButtons.vue?vue&type=template&id=3488fd01&scoped=true&"
import script from "./NextPrevButtons.vue?vue&type=script&lang=ts&"
export * from "./NextPrevButtons.vue?vue&type=script&lang=ts&"
import style0 from "./NextPrevButtons.vue?vue&type=style&index=0&id=3488fd01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488fd01",
  null
  
)

export default component.exports